import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
} from "@suid/material";

export const Login = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.05)",
      }}
    >
      <Card sx={{ minWidth: 345, textAlign: "center", p: 2 }}>
        <CardContent>
          <Typography variant="h5" component="div" gutterBottom>
            Welcome
          </Typography>
          <Typography sx={{ mb: 1.5 }} color="text.secondary">
            Click the button below to login with your Google account.
          </Typography>
          <Button component="a" href="/auth/google" rel="external" variant="contained" sx={{ mt: 2 }}>
            Login with Google
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};
